<script lang="ts">
    import { onMount } from "svelte";
    import { appstates } from "../../../stores/app-state";
    import Step from "../../common/step.component.svelte";
    import * as questionsJSON from "../../../json/questions.json";
    import QuestionItem from "./question-item.component.svelte";
    import type { Question } from "../../../models/question";
    import { RequirementStore } from "../../../stores/requirement-store";

    // Export
    export let title: string = "";

    let questions : Question[] = [];

    // Reactive
    // -- Next possible ?
    $: nextEnable = true;

    // Function
    // -- onMount
    onMount(() => {
        questions = RequirementStore.getQuestions();
    });
    // -- HandleNext
    const handleNext = () => {
        // Check
        if (nextEnable) {
            RequirementStore.updateQuestions(questions);
            appstates.next();
        }
    };
    // -- Handle Answer
    const handleAnswer = (e: CustomEvent<Question>) => {
        // Question is in the list ?
        const index = questions.indexOf(e.detail); 
        if( index >= 0) {
            questions[index] = e.detail;
        } else {
            questions = [
                ...questions,
                e.detail
            ]
        }
    }
    // -- Get the question
    const getQuestion = (questionFromJson: Question) => {
       // Find
       const q = questions.find(q => q.id === questionFromJson.id);
       if(q) { return q};
       return questionFromJson;
    }


</script>

<Step title={ title } {nextEnable} on:navigation-next={handleNext} imageIndex= { $appstates } >
    <span slot="presentation">
        Une liste de questions pour finaliser le périmètre de votre projet. Si
        vous n'avez pas toutes les réponses, ce n'est pas grave. Ce sera
        l'occasion d'échanger ensemble. <br>
        Aucune question n'est obligatoire.
    </span>

    <span slot="content">
        {#each questionsJSON.list as categorie}
            <h3>{categorie.title}</h3>
            <ul>
                {#each categorie.questions as question}
                    <li><QuestionItem question={ getQuestion(question) } on:question-answer={handleAnswer} /></li>
                {/each}
            </ul>
        {/each}
    </span>
</Step>

<style>

    ul {
        padding-left: 0px;
    }

    li {
        padding-bottom: 10px;
    }

</style>
